import { useDispatch } from "react-redux";

import { cartSlice } from "../slices/cartSlice";

export const useCartClear = (): VoidFunction => {
  const dispatch = useDispatch();
  return (): void => {
    const action = cartSlice.actions.next(null);
    dispatch(action);
  };
};
